var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coperight-container"},[_c('Img',{attrs:{"width":'33.3rem',"height":'6.3rem',"url":this.footLogo.logo + '.png'}}),_c('p',[_vm._v(_vm._s(_vm.$t('footer.coperight')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }